import { EiffageScan } from '@willie/schemas'

export const STATUS_LABELS: Record<EiffageScan['status'], string> = {
  completed: 'Terminé',
  processing: 'En traitement',
  validation: 'En validation',
  failed: 'Échec',
  pending: 'En attente'
}
